import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import get from 'lodash/get';
import {
  API,
  GlobalActions,
  NavigationHelper,
  OrderTypeHelper,
  Field2 as Field,
  TableFlights,
  VibeModal,
  viAdd,
  viKeyboardTab,
  viLock,
  viInfinity,
  withRouter,
} from 'vibeguide';
import C, { lower } from 'constants';
import SubNavigation from '../../Header/SubNavigation';
import FlightSidebar from './Sidebar/FlightSidebar';
import './FlightContainer.scss';

function FlightContainer({
  className = '',
  user,
  setPanel,
  history,
}) {
  const [numAwaitingApproval, setNumAwaitingApproval] = useState(0);
  const qs = NavigationHelper.getParams() || {};

  const [newFlightModalOpen, setNewFlightModalOpen] = useState(qs.type === 'new');
  const [orderType, setOrderType] = useState(qs.orderType ?? null);

  const sidebar = (type) => {
    setPanel({
      show: true,
      backdrop: type === 'new',
      width: 400,
      children: (
        <FlightSidebar
          orderType={orderType}
        />
      ),
    });

    // reset flight type if they try to create another flight
    setOrderType(null);
  };

  /**
   * Cancel creating a new flight (proposal)
   */
  const onCancelCreateFlight = () => {
    setNewFlightModalOpen(false);
    setOrderType(null);

    const url = NavigationHelper.updateParams({
      type: null,
    }, {
      keepPage: true,
    });

    history(url);
  };

  /**
   * Confirm creating a new flight (proposal)
   */
  const onConfirmCreateFlight = () => {
    setNewFlightModalOpen(false);
    sidebar('new', orderType);
  }

  useEffect(() => {
    const isNew = qs.type === 'new';
    // const isView = qs.flightId && qs.type !== 'new';

    // if (isNew || isView) {
    if (isNew && !newFlightModalOpen) {
      setNewFlightModalOpen(true);
      // sidebar(qs.type);
    }
  }, [qs.type]);
  // }, [qs.type, qs.flightId]);

  useEffect(() => {
    // get the number of flights awaiting approval
    async function fetchData() {
      const flightsAwaitingApproval = await API.Flight.list({
        filters: {
          active: true,
          status: 'awaiting-approval',
        },
        pageSize: -1,
      });

      setNumAwaitingApproval(flightsAwaitingApproval.data.length);
    }
    fetchData();
  }, []);

  return (
    <div className={classNames('FlightContainer', className)}>
      <SubNavigation
        title={C.PROPOSALS}
        buttons={[
          {
            text: `New ${C.PROPOSAL}`,
            icon: viAdd,
            userCan: [
              'flight.create',
            ],
            color: 'primary',
            url: NavigationHelper.updateParams({
              type: 'new',
            }),
          },
        ]}
      />

      <TableFlights
        columns={[
          'Name',
          `${C.PROPOSAL} Type`,
          'Owner/Partner',
          'Status',
          'Creative',
          'Opportunity',
          'Opportunity ID',
          'Deal ID',
          'Company',
          'Order Reference ID',
          'Delivery System',
          'Ad Provider',
          'Advertiser',
          'Ad Category',
          'Currency',
          'Start Date',
          'End Date',
          'Created By',
          'Created Date',
          '...',
        ]}
        fetch={API.Flight.list}
        defaultSortBy={{
          label: 'Created Date',
          attr: 'createdDate',
          direction: 'desc',
        }}
        paginator
        paginatorProps={{
          label: C.PROPOSALS,
          urlPaging: true,
          urlFilters: true,
        }}
        toggle
        toggleProps={{
          label: `Show Archived ${C.PROPOSALS}`,
          tooltip: true,
        }}
        submenu
        submenuProps={{
          rootUrl: `/ad-ops/${lower(C.PROPOSALS)}`,
          items: [
            {
              name: 'All',
              paginatorLabel: C.PROPOSALS,
              show: true,
              enabled: true,
            },
            {
              name: 'Awaiting Approval',
              label: `Awaiting Approval ${numAwaitingApproval > 0 ? `(${numAwaitingApproval})` : ''}`,
              filters: {
                status: 'awaiting-approval',
              },
              show: user.can('flight.approve') || user.can('flight.global_approver'),
              enabled: true,
              // custom columns for the tab
              columns: [
                'Name',
                'Opportunity ID',
                'Order Reference ID',
                'Start Date',
                'End Date',
                'Created By',
                'Approver',
                'Approver Setting',
                'Created Date',
                'Company',
                'Creative',
                'Opportunity',
                'Deal ID',
                'Delivery System',
                'Ad Provider',
                'Advertiser',
                'Ad Category',
                'Currency',
                '...',
              ]
            },
          ],
        }}
        rowLink={`/ad-ops/${lower(C.PROPOSAL)}/{_id}`}
        menuItems={[
          {
            name: 'Archive',
            // Allow archive if the user has permission and the row is unconfirmed
            userCan: (row) => user.can('flight.delete') && get(row, 'status') === 'unconfirmed',
          },
        ]}
      />

      <VibeModal
        type="confirm-create"
        show={newFlightModalOpen}
        width={500}
        confirmProps={{
          text: 'Create',
          disabled: orderType === null,
        }}
        title={`Create New ${C.PROPOSAL}`}
        onConfirm={onConfirmCreateFlight}
        onClose={onCancelCreateFlight}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 16,
          }}
        >
          {OrderTypeHelper.list().filter(type => type.value !== 'direct-ext').map(orderTypeItem => (
            <Field
              key={orderTypeItem.value}
              type="radio"
              label={orderTypeItem.label}
              radioProps={{
                selected: orderType === orderTypeItem.value,
                icon: orderTypeItem.icon,
                iconPlacement: 'right',
                description: orderTypeItem.description,
              }}
              onClick={() => setOrderType(orderTypeItem.value)}
            />
          ))}
        </div>
      </VibeModal>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    user: state.login.user,
  };
}

const mapDispatchToProps = {
  setPanel: GlobalActions.setPanel,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FlightContainer));
